export const Mood = {
  themeName: "Mood",
  isDark: false,
  CardViewBgColor: "#f1eef6bb",
  connectBtn: "#222222",
  label: "#5DBC4E",
  loader: "#5DBC4E",
  headerColor: "#222222",
  offline: "#ec4545",
  offlineLabel: "#838383",
  primaryColor: "#515050B2",
  welcomeBg: "#CBDBDF",

  textColor: "#222222",
  labelColor: "#8A8A8A",
  listBg: "#ffffff",

  settingCollapseColor: "#eee",
  separatorColor: "#aaa",

  fapMap: "#aaa",
  danger: "#EE6E6E",
  warning: "#e59d4b",
  welcomeBg: "#D7E3E3",
  success: "#3ecd7e",
  playerControl: "#FFFFFF30",
  whiteToast: "#FFF",
  blazeOrangeToast: "#FE6301",
  mantisToast: "#69C779",
  altoToast: "#D8D8D8",
  dustyGrayToast: "#979797",
  infoToast: "#6FFFDC",
  yellowToast: "#edc300",
  greyToast: "#ccc",
  grayToast: "#aaa",
  lightToast: "#e5e2ec",
  appBg: "#f8f8f8",
  appBorder: "#e7e7e7",
  groupIcon: "#ffffff",

  borderRecord: "#51505040",
  borderFormInput: "#eee",
  swipableBg: "#ffffff",
  landingScreenModeBg: "#F3F3F3",
  calenderBorder: "#CBDBDF",
  cancelButton: "#eee",
  listPlaceHolder: "#eee",
  fapMapBg: "#ffffff",
  fapMapActive: "#222222",
  listBgCard: "#eee",
  noItemToDisplay: "#ccc",
  listItem: "#ffffff",
  linkColor: "#1D9BF0",
  colorTextInput: "#222222",
  LogincolorTextInput: "#222222",
  headerPrimary: "#22222200",
  headerDark: "#29292900",
  headerText: "#222222",

  //notification colors
  //1
  notificationUpColor: "#F7F8FD",
  notificationDownColor: "#EAEDFA",
  //2
  listItemNotificationDownColor: "#F2F4FC",
  listItemNotificationUpColor: "#E2E5F9",
  //3
  listItemOfflineUpColor: "#FFFFFF",
  listItemOfflineDownColor: "#EAEDFA",

  SelectedDrawerItem: "#F2F4FC",

  //login text input
  //bg colors
  bgLoginInput: "#ffffff",
  //border colors
  notfocusedBorderLoginInput: "#eeeeee",
  focusedBorderLoginInput: "#08A152",
  //label colors
  focusedLabelLoginInput: "#08A152",
  notFocusedLabelInput: "#aaaaaa",
  loginText: "#222222",
  LogincolorLabelInput: "#aaaaaa",
  //icons colors
  resetInputLogin: "#08A152",
  containerLanguageIcon: "#ffffff00",

  loginFooter: "#222222",
  loginBgFooter: "#fff",
  languageIcon: "#222222",
  loginOptions: "#ffffff",

  //connect button colors
  bnConnect: "#5DBC4E",
  loginBtnLabel: "#ffffff",
  shadowBtnConnect: "#5DBC4E33",

  //app colors
  iconAppItem: "#5DBC4E",
  AppText: "#222222",

  //primary colors
  primary: "#18266D",
  primaryDark: "#0A1A6B",
  primaryLight: "#18266D40",

  //secondary colors
  secondary: "#5DBC4E",
  secondaryLight: "#5DBC4E80",

  loginBgFooter: "#fff",
  //Costum4
  loginFirstTabTitle: "#222",
  loginTabTitle: "#222",
  loginTabSelected: "#fff",
  loginTabNotSelected: "#ffffff4d",

  //CustomLanguge Modal
  languageContainerLeft: "#fff",
  languageContainerRight: "#5DBC4E",
  submitLeftConnect: "#222",
  submitRightConnect: "#fff",
};
